import axios from 'axios';

const API_URL = '/api/tenant/customers';

export const fetchCustomers = async (params) => {
  try {
    const queryParams = {
      page: params.page,
      pageSize: params.itemsPerPage || 10,
      q: params.q,
      sortBy: params.sortBy,
      sortDesc: params.sortDesc,
    };

    Object.keys(queryParams).forEach((key) => {
      if (
        (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') &&
        key !== 'page' &&
        key !== 'pageSize'
      ) {
        delete queryParams[key];
      }
    });

    const response = await axios.get(API_URL, {
      params: queryParams,
      paramsSerializer: (params) => {
        const qs = require('qs');
        return qs.stringify(params, { arrayFormat: 'brackets' });
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

export const getCustomerById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching customer ${id}:`, error);
    throw error;
  }
};

export const createCustomer = async (customerData) => {
  try {
    const response = await axios.post(API_URL, customerData);
    return response.data;
  } catch (error) {
    console.error('Error creating customer:', error);
    throw error;
  }
};

export const updateCustomer = async (id, customerData) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, customerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating customer ${id}:`, error);
    throw error;
  }
};

export const deleteCustomer = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting customer ${id}:`, error);
    throw error;
  }
};
